import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';
import ManagePrograms from 'src/components/Elements/ManagePrograms';

const ProgramManagementModal = () => (
  <ModalBase
    name={MODALS.managePrograms}
    size={MODALS_SIZE.small}
    form={FORM.get_programs}>
    <ManagePrograms />
  </ModalBase>
);

export default ProgramManagementModal;
